var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',_vm._l((_vm.errors),function(error,i){return _c('v-alert',{key:i,staticClass:"mt-1 mb-2 py-3",attrs:{"color":"error","dense":"","text":""}},[_vm._v(" "+_vm._s(error[0])+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }